export const DEFAULT_CONTENT = {
  id: "site",
  hero: {
    headline_line1: "Small Apps,",
    headline_line2: "Big Joy.",
    subheadline:
      "Play Fox Studio builds simple, engaging mobile experiences — tiny moments of delight, crafted with indie care. Bold ideas, friendly interfaces, no clutter.",
    primary_cta_label: "Meet Clever Canine",
    secondary_cta_label: "Explore Portfolio",
    badge_label: "Indie Studio · Est. 2024",
    phone_screen_image_id: null,
    floating_banners: [
      { icon: "Heart", label: "WAG-O-METER · 92%", position: "top-left", variant: "soft", visible: true },
      { icon: "Sparkles", label: "PUP PULSE · TODAY", position: "bottom-right", variant: "orange", visible: true },
    ],
    rating_visible: true,
    rating_value: "4.8",
    rating_label: "avg rating",
    tagline_visible: true,
    tagline_text: "Built for everyday joy",
    new_badge_visible: true,
    new_badge_label: "NEW",
    new_badge_text: "Clever Canine v1.2",
  },
  featured: {
    eyebrow: "Featured App",
    badge_label: "Now on iOS",
    title_line1: "Clever Canine — a friendlier way",
    title_line2: "to know your dog.",
    description:
      "Built for dog owners and dog lovers, Clever Canine turns daily care into small wins. Identify breeds in seconds, log happy moments, and get tiny nudges that make every walk a little more wonderful.",
    pillars: [
      { icon: "Search", title: "Breed Detective", desc: "Snap a photo and learn your pup’s likely mix — quick, playful, and trustworthy." },
      { icon: "HeartPulse", title: "Wag-O-Meter", desc: "Track happy moments and routines with featherlight daily check-ins." },
      { icon: "Activity", title: "Pup Pulse", desc: "A simple dashboard for your dog’s day-to-day wellbeing — always glanceable." },
    ],
    app_store_url: "#",
    learn_more_url: "#",
    checks: ["Designed for iPhone", "Privacy-first by default", "Tiny app, tiny battery"],
    hero_image_id: null,
    phone_screen_image_id: null,
    floating_banners: [],
  },
  portfolio: {
    eyebrow: "The Portfolio",
    title_line1: "Coming soon to a phone",
    title_line2: "near you.",
    description:
      "A few small worlds we’re quietly crafting next. Friendly, focused, and short enough to play on a coffee break.",
    follow_cta_label: "Get release pings",
    cards: [
      { id: "sleepy-sloth", title: "Sleepy Sloth", tag: "Cozy Puzzle", desc: "A gentle nightly puzzle that helps you unwind. Tap, drift, repeat — ten minutes max.", eta: "Q2 2026", coming_soon: true, image_id: null },
      { id: "cosmic-cat", title: "Cosmic Cat", tag: "Space Arcade", desc: "A pocket-sized arcade about a tiny astronaut cat bouncing between friendly planets.", eta: "Q3 2026", coming_soon: true, image_id: null },
      { id: "pixel-picnic", title: "Pixel Picnic", tag: "Collect-em-up", desc: "Pack the perfect blanket. A breezy collecting game with charming pixel snacks.", eta: "Q4 2026", coming_soon: true, image_id: null },
    ],
  },
  about: {
    eyebrow: "About Us",
    title_line1: "We make simple,",
    title_line2: "fun tools — small on purpose.",
    description:
      "Play Fox Studio is a tiny, independent shop building mobile apps and games that feel handcrafted. We believe the best software respects your time, attention, and battery. Small enough to feel personal, polished enough to feel premium.",
    mission: "ship one delightful little app at a time.",
    values: [
      { icon: "Sparkles", title: "Delight", desc: "Tiny moments of joy in everyday tasks. Apps that make you smile, not stall." },
      { icon: "Eye", title: "Clarity", desc: "One screen, one decision. We strip features until only the loved ones remain." },
      { icon: "Wrench", title: "Craft", desc: "Premium feel on a small canvas. Every pixel earns its place." },
    ],
  },
  footer: {
    tagline:
      "Small Apps, Big Joy. An independent studio crafting simple, friendly mobile experiences.",
    email: "hello@playfoxstudio.com",
    follow_blurb: "We post devlogs, behind-the-scenes art, and tiny launches.",
    socials: [
      { id: "x", url: "#", visible: false },
      { id: "instagram", url: "#", visible: false },
      { id: "tiktok", url: "#", visible: false },
      { id: "youtube", url: "#", visible: false },
    ],
    privacy_policy:
      "What we collect. Our apps are designed to work with as little personal data as possible. Some features (like Clever Canine’s Wag-O-Meter) store information locally on your device.\n\nWhat we don’t do. We don’t sell your data, we don’t share it with advertisers, and we don’t require accounts to enjoy the basic experience.\n\nCrash and usage analytics. If you opt in, anonymized usage data may help us improve features and fix bugs. You can opt out anytime in app settings.\n\nContact. Questions about privacy? Email hello@playfoxstudio.com.\n\nThis summary is informational and will be replaced with a full legal policy ahead of launch.",
    copyright_text: "Made with care — and the occasional fox nap.",
    privacy_last_updated: "",
    abn: "",
  },
};
